/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, useParams } from "react-router-dom";
// import ContactDetail from "./ContactDetail";
// import Practise from "./Practise";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import FormBuilder from "./FormBuilder";
import { getSingleBlog } from "../../lib/Services_with_Query";
import Loader from "../../Component/Loader/Loader";

function BlogDetail() {
  const { id } = useParams();

  const { website } = useSelector((state) => state?.website || {});
  const website_id = website?.website_id && website?.website_id;
  const agent_id = website?.agent_id && website?.agent_id;
  const shouldFetch = website_id && agent_id ? true : false;

  const { data, isLoading } = useQuery({
    queryFn: () => getSingleBlog(id),
    enabled: shouldFetch,
  });
  if (isLoading) return <Loader />;

  return (
    <main>
      <section className="page-area area-120">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 justify-content-start align-items-center">
              <div className="breadcrumb-title text-center">
                <div className="white-headline">
                  <h2>
                    Service <span className="sp-color">details</span>
                  </h2>
                </div>
              </div>
              <div className="breadcrumb-page">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb ">
                    <li className="breadcrumb-item">
        
                        <Link
                          to={'/'}
                        >
                          Home
                        </Link>
        
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Service Details
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Breadcrumb Area */}
      {/*Blog Area Start*/}
      <div className="blog-area blog-details fix area-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-sm-8 col-xs-12">
              {/* single-blog start */}
              <article className="blog-post-wrapper">
                <div className="blog-banner">
                  <div className="blog-image">
                    <a className="image-scale" href="">
                      <img src={data?.image} alt="" />
                      <div className="blog-item-date">
                        <span className="date-type">28</span>
                        <span className="years-type">Aug, 22</span>
                      </div>
                    </a>
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <span className="admin-type">
                        <i className="fa fa-user" />
                        Admin
                      </span>
                      <span className="comments-type">
                        <i className="fa fa-comment-o" />
                        16
                      </span>
                    </div>

                    <div
                      dangerouslySetInnerHTML={{ __html: data?.description }}
                    ></div>
                  </div>
                </div>
              </article>

              {/* single-blog end */}
            </div>
            {/* Start Right Sidebar blog */}
            {/* <ContactDetail /> */}
            <FormBuilder />

            {/* End Right Sidebar */}
          </div>
          {/* End row */}
        </div>
      </div>
      {/*End of Blog Area*/}
      {/* Start Quote Area */}

      {/* End Quote Area */}
    </main>
  );
}

export default BlogDetail;
